import React from "react";
import sideimg from "../../Assets/img/Process.png"
const Discover = () => {
  return (
    <div className="container py-5">
      <div className="row align-items-center">
        <div className="col-lg-6 mb-4 mb-lg-0">
          <h4 className="highlight-title">Smart Talent Discovery & Hiring</h4>
          <p className="paragraph">
            Discover and hire the right talent faster with our intelligent hiring platform. Access curated candidate profiles, advanced search tools, and expert-matched professionals aligned with your role, skills, and business goals—helping you make confident hiring decisions with lasting impact.
          </p>
          {/* <h4 className="highlight-title mt-4">
            Put Your Opportunities in Front of the Right People
          </h4> */}
          <p className="paragraph">
           Our advanced matching and search capabilities. ensure your job opportunities reach candidates who not only meet your technical requirements but also align with your company’s vision and culture. Whether you are building long-term teams or hiring for project-based roles, our platform simplifies the hiring process, reduces time-to-hire, and supports sustainable business growth with smarter talent decisions.
          </p>
        </div>

        <div className="col-lg-6">
          <div className="row g-3">
            <img src={sideimg}  />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discover;
